import defaultAvatar from "../../assets/logo/logo.png";
import { API_BASE_URL } from "../../services/api";
import { useState } from "react";
import { MapContainer, TileLayer, Marker, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { XCircle } from "lucide-react";

export default function OrderDetailsView({ order, onDeleteSupplement }) {
  const [openTrip, setOpenTrip] = useState(null);
  if (!order) return null;

  const startIcon = L.icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
    iconSize: [28, 28],
    iconAnchor: [14, 28],
  });

  const endIcon = L.icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/149/149059.png",
    iconSize: [28, 28],
    iconAnchor: [14, 28],
  });

  const driverAvatar = order?.driver?.user?.profilPicture
    ? `${API_BASE_URL.replace("/api", "")}/images/user/${order.driver.user.profilPicture}`
    : defaultAvatar;

  const customerAvatar = order?.customer?.user?.profilPicture
    ? `${API_BASE_URL.replace("/api", "")}/images/user/${order.customer.user.profilPicture}`
    : defaultAvatar;

  return (
    <div className="tripCard modern pageMode">
      <div className="tripTop">
        <div>
          <div className="tripId">Trajet #{order.id}</div>
          <div className="tripDate">
            Lancée le: {new Date(order.created_at).toLocaleString("fr-FR")}
          </div>
        </div>
        <div className="tripRight">
          <div
            className={`statusBadge ${order.statut?.name?.replace(/\s+/g, "")}`}
          >
            {order.statut?.name}
          </div>
          <div className="tripPriceBig">{order.amount} CFA</div>
        </div>
      </div>

      <div className="tripGrid">
        <div className="leftColumn">
          <div className="tripBlock">
            <div className="blockTitle">Participants</div>
            <div className="usersGrid">
              <UserCard
                avatar={customerAvatar}
                name={`${order.customer?.user?.firstName} ${order.customer?.user?.lastName}`}
                phone={order.customer?.user?.contact?.tel}
                role="Client"
              />
              {order.driver ? (
                <UserCard
                  avatar={driverAvatar}
                  name={`${order.driver?.user?.firstName} ${order.driver?.user?.lastName}`}
                  phone={order.driver?.user?.contact?.tel}
                  role="Chauffeur"
                />
              ) : (
                <div className="modernUserCard">
                  <div className="modernUserName">Chauffeur non assigné</div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="rightColumn">

          <div className="tripBlock">
            <div className="blockTitle">Informations de la commande</div>
            <div className="vehicleGrid">
              <VehicleItem label="Type" value={order.order_type?.name} />
              <VehicleItem label="Montant" value={`${order.amount} CFA`} />
              <VehicleItem
                label="Distance"
                value={`${order.distanceTravelled} m`}
              />
            </div>
          </div>

          <div className="tripBlock">
            <div className="blockTitle">Suppléments / Frais divers</div>
            <div className="supplementsGrid">
              {order.supplements?.length > 0 ? (
                order.supplements.map((sup) => (
                  <div key={sup.id} className="supplementRow">
                    <div className="supDetail">
                      <span className="supReason">{sup.reason}</span>
                      <span className="supPrice">+{sup.amount} CFA</span>
                    </div>
                    <button
                      className="btnIconDelete"
                      onClick={() => onDeleteSupplement(sup.id)}
                    >
                      <XCircle size={16} />
                    </button>
                  </div>
                ))
              ) : (
                <div className="noDataSmall">
                  Aucun supplément sur cette commande
                </div>
              )}
            </div>
          </div>

          <div className="tripBlock tripsSection">
            <div className="blockTitle">
              Historique des trajets ({order.trips?.length || 0})
            </div>
            {order.trips?.map((trip, index) => {
              const isOpen = openTrip === trip.id;
              const hasCoords =
                !isNaN(Number(trip.startLatitude)) &&
                !isNaN(Number(trip.endLongitude));
              return (
                <div key={trip.id} className="tripSubCard">
                  <div
                    className="tripSubHeader"
                    onClick={() => setOpenTrip(isOpen ? null : trip.id)}
                  >
                    <div>
                      <div className="tripNumber">Trip #{index + 1}</div>
                      <div className="tripMeta">
                        {trip.distance} m • {trip.duration} min
                      </div>
                    </div>
                    <div className="tripRightMeta">
                      <div className="tripAmount">{trip.amount} CFA</div>
                      <div className="tripToggle">{isOpen ? "▲" : "▼"}</div>
                    </div>
                  </div>
                  {isOpen && hasCoords && (
                    <div className="tripMap">
                      <MapContainer
                        center={[
                          Number(trip.startLatitude),
                          Number(trip.startLongitude),
                        ]}
                        zoom={14}
                        style={{ height: "200px", width: "100%" }}
                      >
                        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
                        <Marker
                          position={[
                            Number(trip.startLatitude),
                            Number(trip.startLongitude),
                          ]}
                          icon={startIcon}
                        />
                        <Marker
                          position={[
                            Number(trip.endLatitude),
                            Number(trip.endLongitude),
                          ]}
                          icon={endIcon}
                        />
                        <Polyline
                          positions={[
                            [
                              Number(trip.startLatitude),
                              Number(trip.startLongitude),
                            ],
                            [
                              Number(trip.endLatitude),
                              Number(trip.endLongitude),
                            ],
                          ]}
                          color="#16a34a"
                          weight={4}
                        />
                      </MapContainer>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          
        </div>
      </div>
    </div>
  );
}

function UserCard({ avatar, name, phone, role }) {
  return (
    <div className="modernUserCard">
      <img src={avatar} className="modernAvatar" alt="avatar" />
      <div>
        <div className="modernUserName">{name}</div>
        <div className="modernUserPhone">{phone}</div>
        <div className="modernUserRole">{role}</div>
      </div>
    </div>
  );
}

function VehicleItem({ label, value }) {
  return (
    <div className="vehicleItemModern">
      <div className="vehicleLabel">{label}</div>
      <div className="vehicleValue">{value}</div>
    </div>
  );
}
